const UPDATE_ACTIVE_PRODUCT_FAMILY_DIALOG = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_ACTIVE_PRODUCT_FAMILY_DIALOG'
const UPDATE_INACTIVE_PRODUCT_FAMILY_DIALOG = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_INACTIVE_PRODUCT_FAMILY_DIALOG'
const SET_ACTIVE_PFPS_DIALOG = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/SET_ACTIVE_PFPS_DIALOG'
const SET_INACTIVE_PFPS_DIALOG = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/SET_INACTIVE_PFPS_DIALOG'

const CLEAR_PRODUCT_FAMILY_SELECTION = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/CLEAR_PRODUCT_FAMILY_SELECTION'
const CLEAR_PARTNER_SITE = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/CLEAR_PARTNER_SITE'

const CHANGE_PARTNER_SITE_SEARCH_QUERY = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/CHANGE_PARTNER_SITE_SEARCH_QUERY'
const UPDATE_PRODUCT_FAMILY_PARTNER_SITE_LIST = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_PRODUCT_FAMILY_PARTNER_SITE_LIST'
const UPDATE_SELECTED_PARTNER_SITE = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_SELECTED_PARTNER_SITE'
const UPDATE_SELECTED_PARTNER_SITE_FROM_PFPS ='fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_SELECTED_PARTNER_SITE_FROM_PFPS'

const UPDATE_PRODUCT_FAMILY_LIST = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_PRODUCT_FAMILY_LIST'
const UPDATE_SELECTED_PRODUCT_FAMILY = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_SELECTED_PRODUCT_FAMILY'
const UPDATE_SELECTED_PRODUCT_FAMILY_FROM_PFPS = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_SELECTED_PRODUCT_FAMILY_FROM_PFPS'

const UPDATE_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST'
const CLEAR_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/CLEAR_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST'

const SAVE_SUPPORT_TEAM = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/SAVE_SUPPORT_TEAM'
const DELETE_PFPS_SUPPORT_TEAM = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/DELETE_PFPS_SUPPORT_TEAM'
const DELETE_PFPS_SUPPORT_TEAM_START = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/DELETE_PFPS_SUPPORT_TEAM_START'
const DELETE_PFPS_SUPPORT_TEAM_SUCCESS = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/DELETE_PFPS_SUPPORT_TEAM_SUCCESS'
const DELETE_PFPS_SUPPORT_TEAM_ERROR = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/DELETE_PFPS_SUPPORT_TEAM_ERROR'

const CHANGE_EDIT = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/CHANGE_EDIT'
const UPDATE_EDIT = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_EDIT'
const CHANGE_SELECT_PFPS = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/CHANGE_SELECT_PFPS'
const UPDATE_SELECT_PFPS = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_SELECT_PFPS'

const CHANGE_SEARCH_VALUE = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/CHANGE_SEARCH_VALUE'

const UPDATE_PFPS_ROLES = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_PFPS_ROLES'

const CLEAR = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/CLEAR'
const UPDATE_CURRENT_PAGE = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_CURRENT_PAGE'

const CHANGE_PAGE_SIZE = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/CHANGE_PAGE_SIZE'
const UPDATE_PAGE_SIZE = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_PAGE_SIZE'
const UPDATE_COUNT_SIZE = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/UPDATE_COUNT_SIZE'
const CHANGE_CURRENT_PAGE = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/CHANGE_CURRENT_PAGE'

const FETCH_PARTNER_SITES = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PARTNER_SITES'
const FETCH_PARTNER_SITES_START = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PARTNER_SITES_START'
const FETCH_PARTNER_SITES_SUCCESS = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PARTNER_SITES_SUCCESS'
const FETCH_PARTNER_SITES_ERROR = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PARTNER_SITES_ERROR'

const FETCH_PRODUCT_FAMILIES = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILIES'
const FETCH_PRODUCT_FAMILIES_START = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILIES_START'
const FETCH_PRODUCT_FAMILIES_SUCCESS = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILIES_SUCCESS'
const FETCH_PRODUCT_FAMILIES_ERROR = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILIES_ERROR'

const FETCH_PRODUCT_FAMILY_ENTITIES = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_ENTITIES'
const FETCH_PRODUCT_FAMILY_ENTITIES_START = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_ENTITIES_START'
const FETCH_PRODUCT_FAMILY_ENTITIES_SUCCESS = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_ENTITIES_SUCCESS'
const FETCH_PRODUCT_FAMILY_ENTITIES_ERROR = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_ENTITIES_ERROR'

const FETCH_PRODUCT_FAMILY_PARTNER_SITES = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_PARTNER_SITES'
const FETCH_PRODUCT_FAMILY_PARTNER_SITES_START = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_PARTNER_SITES_START'
const FETCH_PRODUCT_FAMILY_PARTNER_SITES_SUCCESS = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_PARTNER_SITES_SUCCESS'
const FETCH_PRODUCT_FAMILY_PARTNER_SITES_ERROR = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_PARTNER_SITES_ERROR'

const SAVE_SUPPORT_TEAM_REQUEST = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/SAVE_SUPPORT_TEAM_REQUEST'
const SAVE_SUPPORT_TEAM_REQUEST_START = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/SAVE_SUPPORT_TEAM_REQUEST_START'
const SAVE_SUPPORT_TEAM_REQUEST_SUCCESS = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/SAVE_SUPPORT_TEAM_REQUEST_SUCCESS'
const SAVE_SUPPORT_TEAM_REQUEST_ERROR = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/SAVE_SUPPORT_TEAM_REQUEST_ERROR'

const FETCH_PRODUCT_FAMILY_ROLES = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_ROLES'
const FETCH_PRODUCT_FAMILY_ROLES_START = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_ROLES_START'
const FETCH_PRODUCT_FAMILY_ROLES_SUCCESS = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_ROLES_SUCCESS'
const FETCH_PRODUCT_FAMILY_ROLES_ERROR = 'fulcrum/containers/Admin/PartnerSite/PartnerSiteProductFamily/FETCH_PRODUCT_FAMILY_ROLES_ERROR'

const ROW_OPTIONS = Object.freeze({
    10: 10,
    25: 25,
    50: 50
  })


export {
    UPDATE_ACTIVE_PRODUCT_FAMILY_DIALOG,
    UPDATE_INACTIVE_PRODUCT_FAMILY_DIALOG,
    CHANGE_PARTNER_SITE_SEARCH_QUERY,
    UPDATE_PRODUCT_FAMILY_PARTNER_SITE_LIST,
    UPDATE_SELECTED_PARTNER_SITE,
    UPDATE_PRODUCT_FAMILY_LIST,
    UPDATE_SELECTED_PRODUCT_FAMILY,
    SAVE_SUPPORT_TEAM,
    
    DELETE_PFPS_SUPPORT_TEAM,
    DELETE_PFPS_SUPPORT_TEAM_START,
    DELETE_PFPS_SUPPORT_TEAM_SUCCESS,
    DELETE_PFPS_SUPPORT_TEAM_ERROR,

    UPDATE_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST,
    CLEAR_PRODUCT_FAMILY_PARTNER_SITE_TABLE_LIST,
    CHANGE_EDIT,
    UPDATE_EDIT,
    UPDATE_CURRENT_PAGE,
    CLEAR,
    CHANGE_SELECT_PFPS,
    UPDATE_SELECT_PFPS,
    SET_ACTIVE_PFPS_DIALOG,
    SET_INACTIVE_PFPS_DIALOG,
    CHANGE_SEARCH_VALUE,

    UPDATE_SELECTED_PRODUCT_FAMILY_FROM_PFPS,
    UPDATE_SELECTED_PARTNER_SITE_FROM_PFPS,

    FETCH_PARTNER_SITES,
    FETCH_PARTNER_SITES_START,
    FETCH_PARTNER_SITES_SUCCESS,
    FETCH_PARTNER_SITES_ERROR,

    FETCH_PRODUCT_FAMILIES,
    FETCH_PRODUCT_FAMILIES_START,
    FETCH_PRODUCT_FAMILIES_SUCCESS,
    FETCH_PRODUCT_FAMILIES_ERROR,

    FETCH_PRODUCT_FAMILY_ENTITIES,
    FETCH_PRODUCT_FAMILY_ENTITIES_START,
    FETCH_PRODUCT_FAMILY_ENTITIES_SUCCESS,
    FETCH_PRODUCT_FAMILY_ENTITIES_ERROR,

    FETCH_PRODUCT_FAMILY_PARTNER_SITES,
    FETCH_PRODUCT_FAMILY_PARTNER_SITES_START,
    FETCH_PRODUCT_FAMILY_PARTNER_SITES_SUCCESS,
    FETCH_PRODUCT_FAMILY_PARTNER_SITES_ERROR,

    SAVE_SUPPORT_TEAM_REQUEST,
    SAVE_SUPPORT_TEAM_REQUEST_START,
    SAVE_SUPPORT_TEAM_REQUEST_SUCCESS,
    SAVE_SUPPORT_TEAM_REQUEST_ERROR,

    FETCH_PRODUCT_FAMILY_ROLES,
    FETCH_PRODUCT_FAMILY_ROLES_START,
    FETCH_PRODUCT_FAMILY_ROLES_SUCCESS,
    FETCH_PRODUCT_FAMILY_ROLES_ERROR,

    ROW_OPTIONS,
    CLEAR_PRODUCT_FAMILY_SELECTION,
    CLEAR_PARTNER_SITE,
    CHANGE_PAGE_SIZE,
    UPDATE_PAGE_SIZE,
    UPDATE_COUNT_SIZE,
    CHANGE_CURRENT_PAGE,

    UPDATE_PFPS_ROLES
}